import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { Seo } from "./Seo";
import { getSeo } from "@/lib/seo";

const Intro = () => (
  <div className="page-intro" aria-hidden="true">
    <span className="page-intro__mark grid grid-cols-2 gap-1.5">
      {[0, 1, 2, 3].map((i) => (
        <span
          key={i}
          className="block h-3 w-3 rounded-[3px]"
          style={{
            background: i === 0 || i === 3 ? "var(--mint)" : "var(--dark-text)",
          }}
        />
      ))}
    </span>
  </div>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
};

export const Layout = () => {
  const [intro, setIntro] = useState(true);
  const { pathname } = useLocation();
  const seo = getSeo(pathname);
  useEffect(() => {
    const t = setTimeout(() => setIntro(false), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--bg-base)] text-[var(--ink)]">
      <Seo title={seo.title} description={seo.description} path={pathname} suffix={seo.suffix !== false} />
      {intro && <Intro />}
      <ScrollManager />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
